import { Collection, Model } from 'web-mojo';
import { DeviceList } from './Device.js';

class FirmwareAssignment extends Model {
    constructor(data = {}) {
        super(data, {
            endpoint: '/api/firmware/assignment'
        });
    }

    targetLabel() {
        const dev = this.get('device');
        if (!dev) return 'Entire group';
        if (typeof dev === 'object') return dev.name || dev.uuid || `Device #${dev.id}`;
        return `Device #${dev}`;
    }
}

class FirmwareAssignmentList extends Collection {
    constructor(options = {}) {
        super({
            ModelClass: FirmwareAssignment,
            endpoint: '/api/firmware/assignment',
            ...options
        });
    }
}

const FirmwareAssignmentForms = {
    edit: {
        title: 'Firmware Assignment',
        fields: [
            {
                type: 'collection', name: 'device', label: 'Device', columns: 12,
                Collection: DeviceList, labelField: 'name', valueField: 'id',
                maxItems: 10, placeholder: 'Search devices...', emptyFetch: false, debounceMs: 300,
                help: 'Leave blank to apply to every device in the group.',
            },
            {
                name: 'channel', type: 'select', label: 'Channel', columns: 6,
                options: [
                    { label: '— none —', value: '' },
                    { label: 'Stable', value: 'stable' },
                    { label: 'Beta', value: 'beta' },
                    { label: 'Dev', value: 'dev' },
                ],
            },
            {
                name: 'version', type: 'text', label: 'Version Pin', columns: 6,
                placeholder: 'e.g. 1.4.2',
                help: "Pin an exact version — leave blank to track the channel. Use the device panel's dry-run check to verify a pin resolves.",
            },
        ]
    }
};

FirmwareAssignment.EDIT_FORM = FirmwareAssignmentForms.edit;

export { FirmwareAssignment, FirmwareAssignmentList, FirmwareAssignmentForms };
